export function unformatDateTimeIso(payload: string) {
  return payload?.replace(/(\d{2})-(\d{2})-(\d{4})T(\d{2}):(\d{2}):(\d{2}).*/, '$3-$2-$1 $4:$5:$6')
}
export function formatDateTimeIso(payload: string) {
  return payload?.replace(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).*/, '$1-$2-$3T$4:$5:$6')
}
export function formatDateTime(payload: string) {
  return payload?.replace(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).*/, '$3/$2/$1 $4:$5')
}
export function formatDateTimeLocal(payload: string) {
  return payload?.replace(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/, '$3/$2/$1 $4:$5')
}
export function formatTime(payload: string) {
  return payload?.substring(0, 5)
}
export function formatDate(payload: string) {
  return payload?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
}
export function formatCNPJ(payload: string) {
  return payload?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}
export function formatFone(payload: string) {
  return payload?.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
}
export function formatCel(payload: string) {
  return payload?.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3-$4')
}
export function formatCpf(payload: string) {
  return payload?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}
